// src/components/cofounder/ActionsList.js
import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import ActionCard from './ActionCard';
import { useCoFounder } from '../../context/CoFounderContext';

const filters = [
  { key: 'all', label: 'All' },
  { key: 'pending', label: 'Pending' },
  { key: 'completed', label: 'Completed' },
  { key: 'failed', label: 'Failed' }
];

const ActionsList = ({ compact = false }) => {
  const { allActions, confirmAction, rejectAction } = useCoFounder();
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredActions = allActions.filter(a => {
    if (activeFilter === 'all') return true;
    if (activeFilter === 'pending') return a.status === 'pending' || a.status === 'executing';
    if (activeFilter === 'completed') return a.status === 'completed';
    if (activeFilter === 'failed') return a.status === 'failed' || a.status === 'rejected';
    return true;
  });

  const active = filteredActions.filter(a => a.status === 'pending' || a.status === 'executing');
  const completed = filteredActions.filter(a => a.status === 'completed');
  const failed = filteredActions.filter(a => a.status === 'failed' || a.status === 'rejected');

  if (allActions.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-gray-400">
        <Zap size={32} className="mb-2" />
        <p className="text-sm">No actions yet</p>
        <p className="text-xs mt-1 text-center px-4">Actions will appear when coFounder performs business operations</p>
      </div>
    );
  }

  const renderGroup = (items, label) => {
    if (items.length === 0) return null;
    return (
      <div className="mb-4">
        {!compact && (
          <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-1">
            {label}
          </h4>
        )}
        <div className="space-y-2">
          {items.map(action => (
            <ActionCard
              key={action.firestoreId || action.id}
              action={action}
              onConfirm={confirmAction}
              onReject={rejectAction}
              compact={compact}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Filter pills */}
      <div className="flex gap-1 mb-3 flex-wrap">
        {filters.map(f => (
          <button
            key={f.key}
            onClick={() => setActiveFilter(f.key)}
            className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${
              activeFilter === f.key
                ? 'bg-[#190192] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {filteredActions.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-6 text-gray-400">
          <p className="text-xs">No {activeFilter} actions</p>
        </div>
      ) : (
        <div className={compact ? 'space-y-1' : 'space-y-2'}>
          {renderGroup(active, 'Active')}
          {renderGroup(completed, 'Completed')}
          {renderGroup(failed, 'Failed / Cancelled')}
        </div>
      )}
    </div>
  );
};

export default ActionsList;
